import React from 'react'
import PageSingle from './PageSingle'
import PostSingle from '../posts/PostSingle'

export default (props) => {
  const posts = props.data_posts;
  const pages = props.data_pages;

  let all_data = []
  all_data = posts.concat(pages)

  const all_categories = props.data_categories

  // 1. check if this is going to be a category page

  const router_slug = props.match.url.toLowerCase().replace(/\//g,'')

  let is_category = {};
  all_categories.forEach((cat) => {
    if (cat.slug === router_slug){
      all_data = [] // clear out posts object
      is_category = cat;
    }
  })

  // 2. find the ID of CAT that has this match/url/slug
  if ( Object.keys(is_category).length !== 0){
    posts.forEach((item) => {
      item.categories.forEach((cat) => {
        if (cat === is_category.id){
          all_data.push(item)
        }
      })
    })
  }

  console.log(all_data)
  const pageItems = all_data.map((item, i) => {
    return (
      <PageSingle
        key={i} 
        match={props.match.params.id}
        slug={item.slug}
        title={item.title.rendered}
        id={item.id}
        content={item.content.rendered}
        categories={item.categories}
        is_category={is_category}
        data_categories={props.data_categories}
      />
    )
  });
  return (
    <div data-c="PageList">
      <h3>ID: {props.match.params.id}</h3>
      {pageItems}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/pages/PageList.js